import { render, staticRenderFns } from "./editArticle.vue?vue&type=template&id=5ac8a166&scoped=true"
import script from "./editArticle.vue?vue&type=script&lang=js"
export * from "./editArticle.vue?vue&type=script&lang=js"
import style0 from "./editArticle.vue?vue&type=style&index=0&id=5ac8a166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac8a166",
  null
  
)

export default component.exports